<template>
  <div class="text-center">
    <v-dialog
      v-model="cdialog"
      persistent
      width="650"
    >
      <v-card>
        <v-card-title>
          {{ $t("dialog.add-schedule") }}
        </v-card-title>
        <v-divider />
        <v-card-text class="mt-4">
          <v-row>
            <v-col>
              <span>{{ $t("popup.duplicate-project") }}</span>
              <b>«{{ projectScheduled }}».</b>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              {{ $t("popup.duplicate") }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-checkbox
            v-model="checkbox"
            :label="$t('dialog.conflict')"
          />
          <v-spacer />
          <v-btn
            text
            @click="yesPushed"
          >
            {{ $t("dialog.yes") }}
          </v-btn>
          <v-btn
            text
            @click="noPushed"
          >
            {{ $t("dialog.no") }}
          </v-btn>
          <v-btn
            text
            @click="cancelPushed"
          >
            {{ $t("dialog.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    projectScheduled: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialogModel: false,
      checkbox: false,
    };
  },
  computed: {
    cdialog: {
      get() {
        return this.dialogModel;
      },
      set(val) {
        this.dialogModel = val;
      },
    },
  },
  watch: {
    dialog: function () {
      this.dialogModel = this.dialog;
    },
  },
  methods: {
    selectMarker() {
      //
    },
    yesPushed() {
      this.$emit("yes-pushed", this.checkbox);
      this.cdialog = false;
    },
    noPushed() {
      this.$emit("no-pushed", this.checkbox);
      this.cdialog = false;
    },
    cancelPushed() {
      this.$emit("cancel-pushed");
      this.cdialog = false;
    },
  },
};
</script>

<style></style>
